export const canCreateMember = (params) => {
    const { memberExists, memberInformation, isValidMemberInformation, selectedDepartmentId, selectedMembershipId, } = params;
    return Boolean(memberExists === false &&
        memberInformation &&
        isValidMemberInformation === true &&
        selectedDepartmentId &&
        selectedMembershipId);
};
